var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-details__action data-details__action--free-entry",staticStyle:{"cursor":"default"}},[_c('span',[_c('TheFreeSignIcon')],1),_c('span',[_vm._v("Free Entry")])])}
var staticRenderFns = []

export { render, staticRenderFns }